import { WorkflowStepCode } from '@exam-management/graphql';
import { Paper } from '@shared/components';

import { SummaryStatsCard } from '../../components';
import { useQuestionCreationTaskDetails } from '../../providers';

export default function QuestionSummaryDashboard() {
  const { task, status } = useQuestionCreationTaskDetails();

  const requirement = task.metadata?.requirement;

  const singleQuestionCount = requirement?.questionCreationCount ?? 0;
  const requiredSingleQuestionCount = requirement?.requiredQuestionCount ?? 0;
  const itemSetQuestionCount = task.metadata?.requirement.itemSetCondition?.map((itemSet) => {
    const questionCreationCount =
      task.metadata?.requirement.itemSetCreation?.filter(
        (creation) =>
          creation.size === itemSet.size && creation.questionCreationCount === itemSet.size,
      ).length ?? 0;
    return {
      size: itemSet.size,
      count: questionCreationCount,
      needTotal: itemSet.needTotal,
    };
  });

  const calculateTotalItemSetQuestionCount = (): {
    totalQuestionCount: number;
    requiredQuestionCount: number;
  } => {
    const totalQuestionCount =
      task.metadata?.requirement.itemSetCreation?.reduce((total, creation) => {
        return total + creation.questionCreationCount;
      }, 0) ?? 0;
    const requiredQuestionCount =
      task.metadata?.requirement.itemSetCondition?.reduce((total, itemSet) => {
        return total + itemSet.size * itemSet.needTotal;
      }, 0) ?? 0;
    return { totalQuestionCount, requiredQuestionCount };
  };
  const {
    totalQuestionCount: itemSetTotalQuestionCount,
    requiredQuestionCount: itemSetRequiredQuestionCount,
  } = calculateTotalItemSetQuestionCount();
  const totalQuestionCount = singleQuestionCount + itemSetTotalQuestionCount;
  const requiredQuestionCount = requiredSingleQuestionCount + itemSetRequiredQuestionCount;

  if (status.code === WorkflowStepCode.QuestionCreationTodo) {
    return null;
  }

  return (
    <Paper sx={(theme) => ({ display: 'flex', p: theme.spacing(6), gap: theme.spacing(2.5) })}>
      <SummaryStatsCard
        title='Total Questions'
        displayValue={`${totalQuestionCount}/${requiredQuestionCount} ข้อ`}
        color='primary'
      />
      {requiredSingleQuestionCount > 0 ? (
        <SummaryStatsCard
          title='Single Questions'
          displayValue={`${singleQuestionCount}/${requiredSingleQuestionCount} ข้อ`}
        />
      ) : null}
      {itemSetQuestionCount?.map((itemSet) => {
        return (
          <SummaryStatsCard
            key={itemSet.size}
            title={`Item Set: ${itemSet.size}Q`}
            displayValue={`${itemSet.count}/${itemSet.needTotal} Sets`}
          />
        );
      })}
    </Paper>
  );
}
